import React, { useState } from 'react'
import { Row, Col } from 'antd'
import TicketOverview from './TicketOverview'
import EscalationsChart from './EscalationsChart'
import DepartmentTicketsChart from './DepartmentTicketsChart'
import AgentPerformanceLeaderboard from './AgentPerformanceLeaderboard'
import HeatMap from './HeatMap'
import Loader from 'components/loaders/Loader'
import './TicketDashboard.css'
import { useQuery } from '@apollo/react-hooks'
import { GET_TICKET_ANALYSIS } from '../graphql/Queries'
import CustomMeta from 'components/CustomMeta'

export default function TicketDashboard() {
  const [analysisData, setAnalysisData] = useState([])
  const { loading } = useQuery(GET_TICKET_ANALYSIS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setAnalysisData(data.getTicketAnalysis.analysis)
    },
  })

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: '100%',
        }}
      >
        <Loader />
      </div>
    )
  }

  return (
    <>
      <CustomMeta title='Ticket Dashboard' />
      <div className='dashboard-container'>
        <Row gutter={[16, 16]}>
          {/* Left Column */}
          <Col xs={24} lg={6}>
            <TicketOverview overViewData={analysisData} />
          </Col>

          <Col xs={24} lg={18}>
            <div className='charts-row'>
              <div className='chart-col escalations-col'>
                <EscalationsChart
                  escalationsChartData={analysisData.escalationStats}
                />
              </div>
              <div className='chart-col department-col'>
                <DepartmentTicketsChart
                  departmentTicketsChartData={analysisData.openVsResolved}
                />
              </div>
            </div>
            <div className='charts-row'>
              <div className='chart-col leaderboard-col'>
                <AgentPerformanceLeaderboard
                  agentPerformanceLeaderboard={analysisData.agentLeaderboard}
                />
              </div>
              <div className='chart-col heatmap-col'>
                <HeatMap
                  heatMapData={analysisData.heatMapData}
                  monthlyHeatMapData={analysisData.monthlyHeatMapData}
                  dailyHeatMapData={analysisData.dailyHeatMapData}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}
